/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export interface IEditPriceReason {
  editedPriceExcGst?: number | null;
  lastEditedReasonCode?: string | null;
  lastEditedReasonNote?: string | null;
}

export const getEditPriceReason = <T extends IEditPriceReason>(product: T): Partial<T> =>
  typeof product.editedPriceExcGst === "number"
    ? ({
        lastEditedReasonCode: product.lastEditedReasonCode || null,
        lastEditedReasonNote: product.lastEditedReasonNote || null,
      } as Partial<T>)
    : {};
